import dynamic from 'next/dynamic';

import Checkbox from '@components/Checkbox';

import {
  MultiSelectionItemWrapper,
  ExtraFieldValueStyle,
  SubTitle,
  CheckboxLabel,
  PriceWrapper,
} from './MultiSelectionFilterStyle';
import { ListingFilterItemInterface } from './types';

const OriginalPrice = dynamic(
  () => import('@components/ui/price/OriginalPrice')
);

const MultiSelectionItem = ({
  singleItemClassName,
  item,
  subTitleKey,
  value,
  onChange,
}: {
  singleItemClassName?: string;
  item: ListingFilterItemInterface;
  subTitleKey: string;
  value?: boolean;
  onChange: (selected: boolean) => void;
}) => {
  const itemSubTitle = subTitleKey
    ? item?.[subTitleKey as keyof ListingFilterItemInterface]
    : null;

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };
  return (
    <MultiSelectionItemWrapper className={singleItemClassName}>
      <Checkbox
        testid='checkbox'
        onChange={onChange}
        checked={value}
        value={value}
        mode='controlled'
        outlineColor='NL800'
      >
        <CheckboxLabel>
          {truncateText(item?.value, 44)}
          {itemSubTitle ? (
            <SubTitle>{'(' + itemSubTitle + ')'}</SubTitle>
          ) : null}
        </CheckboxLabel>
      </Checkbox>
      {item.extra ? (
        <ExtraFieldValueStyle>
          {item?.extra?.value?.includes('-') ? (
            `${item?.extra?.value}`
          ) : (
            <PriceWrapper>
              <OriginalPrice
                price={Number(item?.extra?.value?.split(' ')[0])}
                currency={item?.extra?.value?.split(' ')[1]}
                noLine
              />
            </PriceWrapper>
          )}
        </ExtraFieldValueStyle>
      ) : null}
    </MultiSelectionItemWrapper>
  );
};

export default MultiSelectionItem;
